import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import {CoilRequest} from '../../model/coil-request';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';


@Component({
    selector: 'app-coil-request',
    templateUrl: './coil-request.component.html',
    styleUrls: ['./coil-request.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class CoilRequestComponent {

  readonly coilRequest = input.required<CoilRequest>();
  readonly title = input.required<string>();
  readonly metricInput = input.required<boolean>();

  getTemperatureUnits(): string {
    return UnitConversionUtils.getTemperatureUnits(this.metricInput());
  }

  getFlowRateUnits(): string {
    return UnitConversionUtils.getFlowRateUnits(this.metricInput());
  }

}
